import { observer } from 'mobx-react-lite'
import { type ProfileViewModel } from '@/features/iam/users/ProfileViewModel'
import { ProfileNav } from '@/features/iam/users/components/ProfileNav'

export interface ProfileNavContainerProps {
  vm: ProfileViewModel
}

export const ProfileNavContainer = observer(function ProfileNavContainer({
  vm,
}: ProfileNavContainerProps) {
  return (
    <ProfileNav
      workspaceName={vm.member.workspace.name}
      shouldShowBilling={vm.shouldShowBilling}
    />
  )
})
